import { DayOfWeek } from '../../enums/DayOfWeek';

/**
 * A class represents an employee being available to work on specific days of a week.
 */
export class Availability {
  dayOfWeek: DayOfWeek;
  startTime: string;
  endTime: string;
  startDate: string;

  /**
   * @param dayOfWeek day of week at which employee is available.
   * @param startTime start time of employee being available.
   * @param endTime end time of employee being available.
   * @param startDate the Monday from which this availability takes effect.
   */
  constructor(dayOfWeek: DayOfWeek, startTime: string, endTime: string, startDate: string) {
    this.dayOfWeek = dayOfWeek;
    this.startTime = startTime;
    this.endTime = endTime;
    this.startDate = startDate;
  }
}
